"use client";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/app/components/shadcn/tooltip";
import { Info } from "lucide-react";
import { ReviewAISummaryData } from "@/app/lib/features/productReview/productReview.types";

interface ReviewSummaryProps {
  data: ReviewAISummaryData;
}

const ReviewSummary = ({ data }: ReviewSummaryProps) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
          <Info className="w-4 h-4 text-blue-600" />
        </div>
        <h3 className="font-semibold">{data.title}</h3>
        <Tooltip>
          <TooltipTrigger>
            <Info className="w-4 h-4 text-gray-400" />
          </TooltipTrigger>
          <TooltipContent variant="white" className="max-w-sm">
            <p className="text-xs">{data.info_text}</p>
          </TooltipContent>
        </Tooltip>
      </div>
      <p className="text-sm text-gray-700 leading-relaxed mb-4">
        {data.content}
      </p>
    </div>
  );
};

export default ReviewSummary;
